/**
 * Which view a scope root opens: the Business workspace or the Data workspace. An explicit choice
 * in this tab wins; otherwise the hostname's first label decides (`data…` or `norn-data-…` → Data,
 * `business…` or `norn-business-…` → Business); every other host keeps Business, today's default.
 */
export type ViewMode = "business" | "data"

const MODE_KEY = "norn.admin.view-mode/1"

export function hostMode(hostname: string): ViewMode | null {
  const label = (hostname.toLowerCase().split(".")[0] ?? "").replace(/^norn-(?=data-|business-)/, "")
  if (label.startsWith("data")) return "data"
  if (label.startsWith("business")) return "business"
  return null
}

export function preferredMode(): ViewMode {
  try {
    const chosen = sessionStorage.getItem(MODE_KEY)
    if (chosen === "business" || chosen === "data") return chosen
  } catch {
    // Storage unavailable: fall through to the hostname.
  }
  return typeof window === "undefined" ? "business" : (hostMode(window.location.hostname) ?? "business")
}

export function rememberMode(mode: ViewMode): void {
  try {
    sessionStorage.setItem(MODE_KEY, mode)
  } catch {
    // A choice that cannot be stored still navigates; it just isn't remembered.
  }
}
